import classNames from 'classnames';
import { Paperclip, ArrowUp } from 'lucide-react';
import styles from './inquiry-toggle.module.scss';

interface InquiryToggleProps {
  isActive?: boolean;
  onToggle?: (active: boolean) => void;
}

export function InquiryToggle({ isActive = false }: InquiryToggleProps) {
  return (
    <div className={classNames(styles.inquiryToggle, { [styles.isActive]: isActive })}>
      <div className={styles.contentWrapper}>
        {/* Inactive Content - Finding Suppliers */}
        <div className={styles.inactiveContent}>
          <span className={styles.searchText}>Finding Suppliers...</span>
          <div className={styles.iconGroup}>
            <button className={styles.iconBtn} type="button">
              <Paperclip />
            </button>
            <button className={styles.arrowBtn} type="button">
              <ArrowUp />
            </button>
          </div>
        </div>

        {/* Active Content - Send Inquiry */}
        <div className={styles.activeContent}>
          <span className={styles.sendText}>Send Inquiry</span>
          <button className={styles.sendArrowBtn} type="button">
            <ArrowUp />
          </button>
        </div>
      </div>
    </div>
  );
}

export default InquiryToggle;
